import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Un chantier « compte » pour un employe s'il porte deja des reserves ou si le
// manager a designe explicitement l'equipe de reception.
export const hasReceptionWork = (p) => {
  const r = p?.reception || {};
  return !!p?.reception_company || (r.open || 0) + (r.done || 0) + (r.validated || 0) > 0;
};

// Un employe ne voit l'onglet Reception que s'il participe a la reception d'au
// moins un chantier (equipe choisie par le manager, par ex. Eco Bati pour Fitou).
// Le manager le voit toujours.
export function useReceptionAccess(isManager) {
  const [access, setAccess] = useState(!!isManager);

  useEffect(() => {
    if (isManager) { setAccess(true); return; }
    let alive = true;
    axios.get(`${API}/reception/summary`)
      .then((res) => { if (alive) setAccess((res.data || []).some(hasReceptionWork)); })
      .catch(() => { if (alive) setAccess(false); });
    return () => { alive = false; };
  }, [isManager]);

  return access;
}
